/**
 * Next.js client instrumentation (https://nextjs.org/docs/app/api-reference/file-conventions/instrumentation-client).
 *
 * Runs once in the browser before the app's frontend code starts, for both the App
 * Router and the Pages Router — the right place for a single, router-agnostic global
 * hook.
 *
 * Installs the post-deploy stale-chunk recovery handler: a deploy rewrites
 * the hashed `/_next/static/chunks/*` filenames, so an already-open client 404s on the
 * chunks it lazily requests and throws a `ChunkLoadError`. The handler reloads once to
 * pull the current asset manifest, guarded against reload loops.
 */

import { installChunkLoadErrorReloadHandler } from '@/utils/chunkLoadReload';

installChunkLoadErrorReloadHandler();
